export default function ProfileHeader({ loading }: { loading: boolean }) {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1">My Profile</h1>
        <p className="text-gray-500 text-sm sm:text-base md:text-lg">Empowering You to Be Heard.</p>
      </div>
      {loading && <div className="text-[#5167b2] text-sm font-medium">Saving changes...</div>}
    </div>
  );
}
